<main class="resume-page">
  <section class="resume-content" aria-labelledby="resume-title">
    <div class="page-heading">
      <p class="location-name">{{ locationName }}</p>
      <app-terminal-context [terminal]="terminal"></app-terminal-context>
      <h1 id="resume-title">
        {{ (tickets.length === 1 ? 'components.resumeTicketsPage.singleTitle' : 'components.resumeTicketsPage.multipleTitle') | translate: { count: tickets.length } }}
      </h1>
      <p>{{ 'components.resumeTicketsPage.description' | translate }}</p>
    </div>

    <div class="resume-actions">
      <button type="button" class="new-ticket-button" (click)="createNewTicket.emit()">
        <mat-icon class="new-ticket-icon" aria-hidden="true">add</mat-icon>
        {{ 'components.resumeTicketsPage.createNew' | translate }}
      </button>
    </div>

    <div class="ticket-list" [attr.aria-label]="'components.resumeTicketsPage.selectTicket' | translate">
      <button
        *ngFor="let item of tickets"
        type="button"
        class="ticket-card"
        [disabled]="!item.canContinue"
        (click)="openTicket(item)"
        [attr.aria-label]="item.ticket.friendlyCode + ' — ' + ('components.resumeTicketsPage.status.' + item.ticket.status | translate) + ' — ' + (item.serviceName || '')"
      >
        <span class="ticket-heading">
          <span class="ticket-code">
            <svg class="ticket-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
              <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
              <path d="M13 5v2M13 17v2M13 11v2" />
            </svg>
            {{ item.ticket.friendlyCode }}
          </span>
          <span class="ticket-heading-actions">
            <span class="ticket-status" [ngClass]="'st-' + item.ticket.status">
              {{ ('components.resumeTicketsPage.status.' + item.ticket.status) | translate }}
            </span>
            <mat-icon *ngIf="item.canContinue" aria-hidden="true">chevron_right</mat-icon>
          </span>
        </span>
        <span class="ticket-service">
          <mat-icon aria-hidden="true">list_alt</mat-icon>
          {{ item.queueName || ('components.resumeTicketsPage.unknownQueue' | translate) }} - {{ item.serviceName }}
        </span>
        <span class="ticket-customer">
          <mat-icon aria-hidden="true">person_outline</mat-icon>
          <span class="customer-details">
            {{ item.customerName || ('components.resumeTicketsPage.unknownCustomer' | translate) }}
          </span>
        </span>
        <span class="ticket-details">
          <ng-container *ngIf="!isPrevisionHidden(item)">
            <span class="ticket-time">
              <mat-icon aria-hidden="true">schedule</mat-icon>
              <span *ngIf="item.ticket.prevision">
                {{ item.ticket.prevision | relativeTimeFormat | async }}
              </span>
              <span *ngIf="!item.ticket.prevision">
                {{ 'components.resumeTicketsPage.noPrevision' | translate }}
              </span>
            </span>
            <span class="ticket-separator" aria-hidden="true">·</span>
          </ng-container>
          <span *ngIf="item.ticket.position > 0" class="ticket-queue-pill">
            {{ item.ticket.position }}º {{ 'components.resumeTicketsPage.position' | translate }}
          </span>
          <span *ngIf="item.ticket.position === 0" class="ticket-queue-pill">
            {{ 'components.resumeTicketsPage.called' | translate }}
          </span>
        </span>
        <span *ngIf="!item.canContinue" class="ticket-unavailable">
          {{ 'components.resumeTicketsPage.unavailable' | translate }}
        </span>
      </button>
    </div>
  </section>
</main>
